import { render, staticRenderFns } from "./AddPainLevelCourseModal.vue?vue&type=template&id=bdc76a12&"
import script from "./AddPainLevelCourseModal.vue?vue&type=script&lang=js&"
export * from "./AddPainLevelCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports